// @ts-nocheck



import React, { Component } from 'react';



import { vehicleTariffEnum } from '../../../lib/enum';

import { withUserAccess } from '../../withUserAccess';
import { InnerList } from '../components';








const COLUMNS = [
{
  title: 'Тип ТС',
  dataIndex: 'vehicleTypeTariff'
}];


export class VehicleTariffTypeList extends Component {
  render() {
    return (
      <>
        <InnerList
          {...this.props}
          type={vehicleTariffEnum.byType}
          extColumns={COLUMNS} />

      </>);

  }
}

export default withUserAccess(VehicleTariffTypeList);
